import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterState : {
        startDate: "",
        endDate: "",
        customerId: "",
        sentType: ""
    }
}

const filterReducer = createSlice({
    name: "filterState",
    initialState,
    reducers: {
        addFilterState: (state, action) => {
            console.log(action.payload);
            state.filterState = { 
                ...state.filterState, 
                ...action.payload 
            };
        },

        removeFilterState: (state) => {
            state.filterState = {
                startDate: "",
                endDate: "",
                customerId: "",
                sentType: ""
            }
        }
    }
})

export const { addFilterState, removeFilterState } = filterReducer.actions;

export default filterReducer.reducer;